import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HomeComponent } from './home/home.component';
import { TicketsComponent } from './tickets/tickets.component';
import { ExploreComponent } from './explore/explore.component';
import { PartnersComponent } from './partners/partners.component';
import { ScheduleComponent } from './schedule/schedule.component';
import { PracticalComponent } from './practical/practical.component';
import { AboutComponent } from './about/about.component';
import { CoachingComponent } from './coaching/coaching.component';
import { SpeakersComponent } from './speakers/speakers.component';
import { SpeakerComponent } from './speaker/speaker.component';
import { TicketRocketDirective } from './ticket-rocket.directive';

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    TicketsComponent,
    ExploreComponent,
    PartnersComponent,
    ScheduleComponent,
    PracticalComponent,
    AboutComponent,
    CoachingComponent,
    SpeakersComponent,
    SpeakerComponent,
    TicketRocketDirective
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FormsModule
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
